module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "impersonate",
    attrs: {
      "title": "Saisir une signature de propale",
      "visible": _vm.visible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      },
      "open": _vm.open,
      "close": _vm.close
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-position": "top",
      "label-width": "150px",
      "model": _vm.form,
      "rules": _vm.fields.validation
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "prop": "id",
      "label": "Selectionnez une propale"
    }
  }, [_c('el-select', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "Propales du client / prospect"
    },
    model: {
      value: (_vm.form.id),
      callback: function($$v) {
        _vm.$set(_vm.form, "id", $$v)
      },
      expression: "form.id"
    }
  }, _vm._l((_vm.proposals), function(proposal) {
    return (proposal.accepted_at === null) ? _c('el-option', {
      key: proposal.id,
      attrs: {
        "label": 'Propale ' + _vm.proposalTypes.find(function (type) { return type.id === proposal.type_id; }).name + ' le ' + _vm.moment(proposal.created_at).format('L'),
        "value": proposal.id
      }
    }) : _vm._e()
  }), 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("Définir comme signée")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bf85348a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./libs/@db2b/keystone/components/Modals/SignProposalModal.vue
// module id = 724
// module chunks = 1